
    <form [formGroup]="form">
      <div a-button class="btn_warn"
           [pending]="(_formService.isPending$ | async)"
           (click)="onStopSprint()"
      >
        Stop Sprint
      </div>
    </form>
  